import { Subscriber, Observable } from 'rxjs';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MapQueryService } from '../../map-query.service';
import Map from 'ol/Map';
import Attribution from 'ol/control/Attribution';
import VectorSource from 'ol/source/Vector';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import OSM from 'ol/source/OSM';
import {Style,Fill, Stroke,Circle} from 'ol/style';
import {Point,Polygon,MultiPoint} from 'ol/geom';
import View from 'ol/View';
import {Draw, Modify, Snap} from 'ol/interaction';
import * as olEventsCondition from 'ol/events/condition';
import LayerSwitcher from 'ol-layerswitcher';
import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-geometry-editor',
  templateUrl: './geometry-editor.component.html',
  styleUrls: ['./geometry-editor.component.scss']
})
export class GeometryEditorComponent implements OnInit,AfterViewInit {

  observer: Subscriber<any>
  loadingLocalidad: boolean = false;
  busquedaLocalidad: string;
  @ViewChild("mapa") mapadiv: ElementRef;
  map: Map;
  parcelasSource: VectorSource;
  geometryToEdit: any;
  config: any = {
    target: 'visormap',
    center : [0,0]
  };
  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  });

  verticesStyle = new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({
        color: 'orange',
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint(coordinates);
    },
  });
  crearParcelaInteraction: any;

  constructor(private mapQueryService: MapQueryService,protected dialogRef: NbDialogRef<any>) { }
  ngAfterViewInit(): void {

      this.initMap();
      if(null != this.geometryToEdit){
        this.pintarParcela(this.geometryToEdit)
      }else{
        this.deleteGeometry();
      }

  }

  ngOnInit(): void {
  }


  initMap() {
    this.mapadiv.nativeElement.innerHTML = "";

    this.parcelasSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
          source: new OSM(),
          visible:false,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer({
          visible:false,
          title: 'Mapa PNOA',
          type:'base',
          source: new WMTS({
            attributions: ['<a href="httpS://www.ign.es" target="_blank">IGN</a>'],
            url: 'http://www.ign.es/wmts/pnoa-ma',
            layer: 'OI.OrthoimageCoverage',
            // matrixSet: 'EPSG:4326',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: olProj.get('EPSG:3857'),
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds
            }),
            style: [this.parcelaStyle,this.verticesStyle]
          })
        }),
        new TileLayer({
          visible: true,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new VectorLayer({
          source: this.parcelasSource,
        }),

      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    var modif =  new Modify({
      source: this.parcelasSource,
      // the SHIFT key must be pressed to delete vertices, so
      // that new vertices can be drawn at the same position
      // of existing vertices
      deleteCondition: function(event) {
        return olEventsCondition.shiftKeyOnly(event) &&
        olEventsCondition.singleClick(event);
      }
    });
    modif.on('modifyend', evt => {

    });
    this.map.addInteraction(modif);
      if(typeof this.crearParcelaInteraction != 'undefined'){
        this.map.addInteraction(this.crearParcelaInteraction)
      }else{

      }
      var layerSwitcher = new LayerSwitcher();
      this.map.addControl(layerSwitcher);

  }

  buscarLocalidad(): void{
    this.loadingLocalidad = true;
    this.mapQueryService.queryLocationByAddress(this.busquedaLocalidad).then((locat)=>{
      this.loadingLocalidad = false;
      this.map.setView(new View({
        center: olProj.fromLonLat([locat.lng,locat.lat]),
        zoom: 17,
      }));
    });
  }

  pintarParcela(field: any): void{
    if(field != null) {

      if( field.type == 'Polygon'){
        field.coordinates[0] = field.coordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }else if(field.type == 'MultiPolygon'){
        field.coordinates[0] = field.coordinates[0][0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }

      let feature = new Feature({
        geometry: new Polygon(
          field.coordinates),

        parcela: {name:field.name,region:field.region},
      });

      feature.setStyle([this.parcelaStyle,this.verticesStyle]);

      this.parcelasSource.addFeature(feature);
      this.map.getView().fit(this.parcelasSource.getExtent(),{padding:[100,100,100,100],nearest:true});


    }else{
      setTimeout(()=> {
        this.map.getView().setCenter([0.1,0.1]);
        this.map.getView().setZoom(1);
        this.map.updateSize();
      },200)
    }
  }

  cargarGeometria(geometria: any){
    console.log(geometria)
    this.geometryToEdit = JSON.parse(JSON.stringify(geometria));
  }

  cancelGeometry(){
    this.dialogRef.close();
  }
  deleteGeometry(){
    this.parcelasSource.clear();
    this.crearParcela();
  }
  saveGeometry(){

    this.observer.next(this.obtenerGemetriaDibujada())
    this.dialogRef.close();
  }
  crearParcela(): void {
    this.crearParcelaInteraction = new Draw({
      source:this.parcelasSource,
      type: 'Polygon',
    })

    this.map.addInteraction(this.crearParcelaInteraction);
    this.map.addInteraction(new Snap({source:this.parcelasSource}));

  }

  obtenerGemetriaDibujada(): JSON {
    if(this.parcelasSource.getFeatures().length > 0){
      var geojson = new GeoJSON();

      var geopolygon = JSON.parse(geojson.writeGeometry(this.parcelasSource.getFeatures()[0].getGeometry()))
      geopolygon.coordinates[0] = geopolygon.coordinates[0].map(function(coordinate){
        return olProj.toLonLat(coordinate);
      })

      return geopolygon;
    }
  }

  getGeometry(): Observable<any> {
    return new Observable(observer => {
      this.observer = observer;
        })
  }
}
